import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import BasicForm from '../basicForm/basicForm';
import './uploadCv.module.scss';
import { validationMessages } from '../../../utils/constants';
import ButtonContainer from '../buttonContainer/buttonContainer';
import FileUploadField from '../../common/FileUploadField/FileUploadField';

function UploadCV(props) {
  const [Cv, setCv] = useState(null);
  const [cvName, setCvName] = useState('');
  const initialErrorValidationValue = {
    cv: false
  };
  const [errors, setErrors] = useState([]);
  const [cvReq, setCvReq] = useState(false);
  const [coverLetter, setCoverLetter] = useState(null);
  const [coverLetterErrors, setCoverLetterErrors] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [certificateErrors, setCertificateErrors] = useState([]);
  const { nextHandle, cancel, data, completedProfile, userDataExist, back, step, totalStep, jobTitle } = props;
  const user = useSelector((state) => state.user?.profile);

  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  useEffect(() => {
    if (user && (completedProfile || userDataExist)) {
      setCvName(user?.CvName);
    }

    if (data.Cv) {
      setCv(data.Cv);
      setCvName(data.Cv.name);
    }
  }, [data, user, userDataExist]);

  const validate = () => {
    const validationObj = {
      ...initialErrorValidationValue
    };

    if (!Cv) {
      validationObj.cv = true;
      setCvReq(true);
    }
    return validationObj;
  };

  return (
    <BasicForm
      cancel={cancel}
      title={`${t('jobs.quickapply.userdetailheader')} ${jobTitle}`}
      progress="40"
      step={step}
      totalStep={totalStep}
    >
      <FileUploadField
        label="Upload Your CV / Resume (Required to Apply)"
        error={errors}
        file={Cv}
        fileName={cvName}
        setFile={setCv}
        setFileName={setCvName}
        setErrors={setErrors}
        validationMessage={validationMessage}
        disabled={completedProfile || userDataExist}
        showReplace={completedProfile || userDataExist}
        cvReq={cvReq}
        errors={errors}
      />

      <div className="d-flex  w-full pt-3 align-self-center">
        <FileUploadField
          label="Add a Cover Letter"
          file={coverLetter}
          setFile={setCoverLetter}
          setErrors={setCoverLetterErrors}
          errors={coverLetterErrors}
          isOptional
        />
      </div>

      <div className="d-flex  w-full pt-3 pb-3 align-self-center">
        <FileUploadField
          label="Add Certificates or Supporting Documents"
          fileList={certificates}
          setFileList={setCertificates}
          setErrors={setCertificateErrors}
          errors={certificateErrors}
          isOptional
          multiple
          maxFiles={3}
        />
      </div>
      <ButtonContainer
        actionCall={() => {
          const validationObj = validate();
          const validationWrongValues = Object.values(validationObj).filter(Boolean);
          if (!validationWrongValues.length) {
            nextHandle({
              Cv,
              CoverLetter: coverLetter,
              ...(certificates[0] && { Document1: certificates[0] }),
              ...(certificates[1] && { Document2: certificates[1] }),
              ...(certificates[2] && { Document3: certificates[2] })
            });
          } else {
            const validationWrongEntries = Object.entries(validationObj).filter((v) => Boolean(v[1]));
            const newErrorValidationValue = {};
            validationWrongEntries.forEach((item) => {
              const [key, value] = item;
              newErrorValidationValue[key] = value;
            });
            // setErrorValidation(newErrorValidationValue);
            // setTimeout(() => setErrorValidation(initialErrorValidationValue), 2000);
          }
        }}
        primaryText={t('common.general.back')}
        secondaryText={t('common.general.next')}
        back={back}
      />
    </BasicForm>
  );
}

export default UploadCV;
